<div class="modal-header">
  <h4 class="modal-title">
    {{'ai-events.undoReason.title' | translate}}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <i class="ico-close sz-xs"></i>
  </button>
</div>

<div class="modal-body">
  <div class="form-group">
    <label for="string">{{'ai-events.undoReason.reason' | translate}}</label>
    <input [formControl]="inputForm" type="text" min="0" class="form-control" id="string">
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="form__action--primary" (click)="activeModal.close(inputForm.value)" role="button">
    <i class="ico-check"></i>
    {{'button.save' | translate}}
  </button>
  <button type="button" class="form__action--danger" (click)="activeModal.dismiss()" role="button">
    <i class="ico-close"></i>
    {{'button.cancel' | translate}}
  </button>
</div>
